__webpack_require__.p = "/daily-prophet/";